import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import moment from "moment";
import { toCamel } from 'snake-camel';
import EmptyGraphMessage from '@/assets/common/AggregationFunction/EmptyGraphMessage/EmptyGraphMessage.vue';
import CultivationHistoryRegisterModal from '@/assets/common/Modal/CultivationHistoryRegisterModal/CultivationHistoryRegisterModal.vue';
import CultivationHistoryPopup from '@/assets/common/Modal/CultivationHistoryPopup/CultivationHistoryPopup.vue';
import CultivationHistoryEditHistoryModal from '@/assets/common/Modal/CultivationHistoryEditHistoryModal/CultivationHistoryEditHistoryModal.vue';
import { SelectedEditHistoryGroup } from '@/assets/common/Modal/CultivationHistoryEditHistoryModal/CultivationHistoryEditHistoryModal';
import { CsvDownload } from '@/types/APIResponse';
import { LoginUser } from "@/types/Component";



@Component({
    components: {
        EmptyGraphMessage,
        CultivationHistoryRegisterModal,
        CultivationHistoryPopup,
        CultivationHistoryEditHistoryModal
    }
})

export default class CultivationHistoryList extends Vue {
    screen = 'CULTIVATIONHISTORYLIST';
    private list: any | null = null
    private title = '栽培履歴一覧'
    baseUrl = '/cultivation_history_list';
    private comBaseUrl = '/shipping_items/producers';
    private comBaseUrlCommit = '/committees';
    selectScreenManagement = '/graphScreenManagement';
    private cultivationHistoryList =  [] as any[];
    private shippingGroupList =  [] as any[];
    private selectedAgriFieldId : string | null = null;
    private selectedPlantingId : string | null = null;
    private totalPlannedHarvestYield : string | null = null;
    private totalActualHarvestYield : string | null = null;
    private totalActualShippingVolume : string | null = null;
    private agriFields = [] as any[];
    private committees = [] as any[];
    private plantings = [] as any[];
    private producers = [] as any[];
    private seedlings = [] as any[];
    private shippingItems = [] as any[];
    private selectedAgriFieldName = '';
    private selectedCommitteeName = '';
    private selectedProducersName = '';
    private selectedWorkItemName = '';
    private selectedAgriFieldNum: string | null = null;
    private selectedCultivationName = null;
    private isSpinnerLoading = false;
    private sortOrder = true;
    private isRefresh = false;
    includeHiddenFlag = false;
    chemicalHiddenFlag = false;
    searchQueryCommittee = '';
    searchQueryPlanting = '';
    searchQueryProducers = '';
    searchQuerySeedlings = '';
    searchQueryShippingItems = '';
    selectedShippingGroupId = '';
    isCommitteesDropdownVisible = false;
    isProducerDropdownVisible = false;
    isShippingItemDropdownVisible = false;
    isPlantingDropdownVisible = false;
    isSeedlingsDropdownVisible = false;
    isReadOnly = false;
    alertFlag = false;
    showCvhModal = false;
    showEditHistoryModal = false;
    mode: string | 'new' | 'edit' = 'new';
    cvId: string | null = null;
    groupId: string | null = null;
    shippingItemId: string | null = null;
    producerId: string | null = null;
    committeeId: string | null = null;
    selectedCommitteeId = ""
    selectedPdId = ""
    private filteredProducer = [] as any[];
    private isCultivationHistoryDetailShow = false;
    private cultivationHistoryId = ""
    private producerPdId = [] as any[];
    selectedShippingItemId  = ''
    private filteredShippingItems = [] as any[];
    private shippingItemsInital = [] as any[];
    private committeeWorkers = [] as any[];
    private cultivationWithProducer = true;
    private cultivationWithOutProducer = true;
    selectedStartDate: string | Date = new Date();
    selectedEndDate: string | Date = new Date();
    private isButtonDisabled = false;
    startDate: string | Date = new Date();
    endDate: string | Date = new Date();
    cultivationStartDate: string | Date = new Date();
    cultivationEndDate: string | Date = new Date();
    cvMethodName= "";
    expandAll=false;
    expandedRows= [] as number[];
    expandedAlertRows= [] as number[];



    get isAdmin(): boolean {
        return this.loginUser.role.find((r: string) => {
            return r === 'ADMIN'
        }) !== undefined;
      }
    
    get loginUser(): LoginUser {
        return this.$store.getters.loginUser;
    }

    get isCultivationListModalOpen():boolean{
        return(
            this.showCvhModal ||
            this.showEditHistoryModal ||
            this.isCultivationHistoryDetailShow
        )
    }

    @Watch('isCultivationListModalOpen')
    onAnyModalVisibilityChanged(val: boolean) {
        this.$root.$emit('header-inert', val);
    }

    openCultivationHistoryRegisterModal(mode: string, cvId: string | null = null, shippingItemId: string | null = null, committeeId: string | null = null, producerId: string | null = null, groupId: string | null = null) {
        this.mode = mode;
        this.cvId = cvId;
        this.groupId = groupId;
        this.shippingItemId = shippingItemId;
        this.committeeId = committeeId;
        this.producerId = producerId;
        this.showCvhModal = true;
    }

    openEditHistory() {
        this.showEditHistoryModal = true;
    }

    onEditHistoryGroupSelected(selection: SelectedEditHistoryGroup) {
        this.openCultivationHistoryRegisterModal('edit', selection.cvId, null, null, null, selection.groupId);
    }

    get isPesticidePlan() : boolean {
        return this.loginUser.isPesticidePlan;
    }

    get pesticidePlanProducer() : boolean {
        return this.loginUser.pesticidePlanProducer;
    }

    private created() {
        this.isSpinnerLoading = true;
        const currentDate = new Date();
        this.selectedStartDate = moment(currentDate).startOf('month').format('YYYY-MM-DD');
        this.selectedEndDate = moment(currentDate).endOf('month').format('YYYY-MM-DD');
        this.getCommitteWorkers();
        this.getCultivationList();
    }

    async getCultivationList() {
       await this.$apiClient.doRequest('get', `${this.baseUrl}?&cultivation_with_producer=${this.cultivationWithProducer}&cultivation_with_out_producer=${this.cultivationWithOutProducer}`).then(res => {
        setTimeout(() => {
            this.isSpinnerLoading = false;
            }, 500);
          this.cultivationHistoryList = res.cultivationList
          this.isReadOnly = res.producerFlag;
          this.shippingGroupList = res.shippingGroup;
          if(res.selectedItems!=null){
            this.searchQueryCommittee = res.selectedItems.comName || ''
            this.searchQueryProducers = res.selectedItems.pdName || ''
            this.searchQueryShippingItems = res.selectedItems.sitemName || ''
            this.searchQueryPlanting = res.selectedItems.plantingName || ''
            this.searchQuerySeedlings = res.selectedItems.cropsFamicName || ''
            this.selectedAgriFieldName = res.selectedItems.agriFieldName || ''
            this.selectedAgriFieldNum = res.selectedItems.agriFieldNum || ''
            this.selectedCultivationName = res.selectedItems.cvMethod
            this.includeHiddenFlag = res.selectedItems.includeHiddenFlag
            this.selectedShippingGroupId = res.selectedItems.shippingOrganizationId
            this.selectedStartDate = res.selectedItems.displayFromDate
            this.selectedEndDate = res.selectedItems.displayToDate
            if ((this.selectedStartDate > this.selectedEndDate) || (this.selectedStartDate === '' && this.selectedEndDate === '') || (this.selectedStartDate === '' && this.selectedEndDate !== '') 
                || (this.selectedStartDate !== '' && this.selectedEndDate === '')) {
                this.isButtonDisabled = true;
              }else{
                this.isButtonDisabled = false;
              }
          } 
          else {
            this.searchQueryProducers = res.producerName;
          }
          if(this.selectedShippingGroupId == '' || this.selectedShippingGroupId == null ){
            if(this.shippingGroupList!=null && this.shippingGroupList.length > 0){
                this.selectedShippingGroupId = this.shippingGroupList[0].tenantId
            }
          }
          this.validateDateCheck();
          const loginUserTenantId = this.$store.getters.tenantId
          if(this.pesticidePlanProducer && (res.selectedItems.pdName !== res.producerName)){
            this.searchQueryProducers = res.producerName;
          }
    
          if(this.isPesticidePlan){
            this.selectedShippingGroupId  = loginUserTenantId
          }
            this.totalPlannedHarvestYield = res.cultivationList.reduce((sum:number, item:any) => {
            const value = parseFloat(item.plannedHarvestYield || "0");
            return sum + value;
            }, 0);

            this.totalActualHarvestYield = res.cultivationList.reduce((sum:number, item:any) => {
            const value = parseFloat(item.actualHarvestYield || "0");
            return sum + value;
            }, 0);

            this.totalActualShippingVolume = res.cultivationList.reduce((sum:number, item:any) => {
            const value = parseFloat(item.actualShippingVolume || "0");
            return sum + value;
            }, 0);
            this.getCommittees();
            this.getShippingItemsByInitial();

            
            if(this.searchQueryCommittee != '' || this.searchQueryProducers != '' || (this.pesticidePlanProducer && this.isPesticidePlan) || (this.pesticidePlanProducer && !this.isPesticidePlan)){
                this.getProducers();
            }
            this.getProducerId();
            setTimeout(() => {
            if(this.searchQueryCommittee!=""){
            const query = this.searchQueryCommittee || '';
            const filtered = this.committees.filter(c => c.name === query);
            if (filtered.length > 0) {
               this.selectedCommitteeId = filtered[0].id;
            }
            }
              this.filterCommitteeName();
              this.filterShippingItems();
              this.filterProducerByShippingItems();
              this.getPlantings();
              this.getSeedlings();
            }, 200);
        })
    }

    refreshTable () {
        this.cultivationHistoryList = []
        this.isSpinnerLoading = true
        this.getCultivationList();
    }

    openCultivationHistoryPopup(id :string) {
        this.cultivationHistoryId = id
        this.isCultivationHistoryDetailShow = true;
    }
    
    handleSearch(flag = true) {
        const errmsg: string[] = []
        if(this.searchQueryCommittee.trim().length > 100){
            errmsg.push(`部会名は100文字以内で入力してください（現在は${this.searchQueryCommittee.trim().length}文字）`)
        }
        if(this.searchQueryProducers.trim().length > 100){
            errmsg.push(`氏名は100文字以内で入力してください（現在は${this.searchQueryProducers.trim().length}文字）`)
        }
        if(this.searchQueryShippingItems.trim().length > 100){
            errmsg.push(`出荷品目は100文字以内で入力してください（現在は${this.searchQueryShippingItems.trim().length}文字）`)
        }
        if(this.searchQueryPlanting.trim().length > 100){
            errmsg.push(`作付名は100文字以内で入力してください（現在は${this.searchQueryPlanting.trim().length}文字）`)
        }
        if(this.searchQuerySeedlings.trim().length > 200){
            errmsg.push(`品種は200文字以内で入力してください（現在は${this.searchQuerySeedlings.trim().length}文字）`)
        }
        if(this.selectedAgriFieldName.trim().length > 100){
            errmsg.push(`圃場名は100文字以内で入力してください（現在は${this.selectedAgriFieldName.trim().length}文字）`)
        }
        if (this.selectedAgriFieldNum && this.selectedAgriFieldNum.trim().length > 20) {
            errmsg.push(`圃場番号は20文字以内で入力してください（現在は${this.selectedAgriFieldNum.trim().length}文字）`)
        }

        if (errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            return false
        }
        const params = {
          comName: this.searchQueryCommittee.trim() === '' ? null : this.searchQueryCommittee.trim(),
          pdName: this.searchQueryProducers.trim() === '' ? null : this.searchQueryProducers.trim(),
          sitemName: this.searchQueryShippingItems.trim() === '' ? null : this.searchQueryShippingItems.trim(),
          plantingName: this.searchQueryPlanting.trim()  === '' ? null : this.searchQueryPlanting.trim(),
          cropName: this.searchQuerySeedlings.trim() === '' ? null : this.searchQuerySeedlings.trim(),
          agriFieldName: this.selectedAgriFieldName.trim() === '' ? null : this.selectedAgriFieldName.trim(),
          agriFieldNum: this.selectedAgriFieldNum === '' ? null : this.selectedAgriFieldNum,
          cvMethod: this.selectedCultivationName === 'null' ? null : this.selectedCultivationName,
          screenName: this.screen,
          includeHiddenFlag: this.includeHiddenFlag,
          shippingOrganizationId: this.selectedShippingGroupId,
          startDate: this.selectedStartDate,
          endDate: this.selectedEndDate,
        }
        
        this.$apiClient.doRequest('post', `${this.selectScreenManagement}`,params).then(res => {
            this.getShippingItems();
            if (flag) {
                this.refreshTable();
            }
        }).catch(error=>{
            this.$toasted.error('データの取得に失敗しました。')
        })
    } 

    async getCommittees() {
    await this.$apiClient.doRequest('get',`/committees/tenantId?with_hidden=true&tenant_id=${this.selectedShippingGroupId}`).then((res) => {
        this.committees = res.committees
    })
    }

    async getProducers() {
       await this.$apiClient.doRequest('get',`/producers/tenantId?with_hidden=true&tenant_id=${this.selectedShippingGroupId}`).then((res) => {
            this.producers = res.producers
            const loginUserId = this.$store.getters.loginUser.id;
            if(this.pesticidePlanProducer && !this.isPesticidePlan ){
              this.producers =  this.producers.filter(
                    producer => producer.pdId === loginUserId
                );
            }
        })
    }

    async getPlantings() {
        if(this.searchQueryCommittee && this.searchQueryProducers && this.selectedCommitteeId && this.selectedPdId){
           await this.$apiClient.doRequest('get',`/plantings/tenantId?with_hidden=true&tenant_id=${this.selectedShippingGroupId}&com_id=${this.selectedCommitteeId}&pd_id=${this.selectedPdId}`).then((res) => {
            this.plantings = res.plantings.sort((a:any,b:any) => a.name.localeCompare(b.name))
           })
        }else{
            this.plantings = [];
        }
    }

   async getSeedlings() {
            if(this.searchQueryCommittee && this.searchQueryProducers && this.selectedCommitteeId && this.selectedPdId){
                await this.$apiClient.doRequest('get',`/seedlings/tenantId?with_hidden=true&tenant_id=${this.selectedShippingGroupId}&com_id=${this.selectedCommitteeId}&pd_id=${this.selectedPdId}`).then((res) => {
                this.seedlings = res.seedlings.sort((a:any,b:any) => a.name.localeCompare(b.name))
            })
            }else{
                this.seedlings = [];
            }
    }

    async getShippingItems() {
        const withHiddenParams =this.includeHiddenFlag  ? true : false
            if(this.selectedCommitteeId && this.selectedPdId){
            await this.$apiClient.doRequest('get',`/shipping_items/tenantId?with_hidden=${withHiddenParams}&tenant_id=${this.selectedShippingGroupId}&com_id=${this.selectedCommitteeId}&pd_id=${this.selectedPdId}`).then((res) => {
            this.shippingItems = res.shippingItems.sort((a:any,b:any) => a.name.localeCompare(b.name));
           })
            }else if(this.selectedCommitteeId){
            await this.$apiClient.doRequest('get',`/shipping_items/tenantId?with_hidden=${withHiddenParams}&tenant_id=${this.selectedShippingGroupId}&com_id=${this.selectedCommitteeId}`).then((res) => {
            this.shippingItems = res.shippingItems.sort((a:any,b:any) => a.name.localeCompare(b.name));
           })
        }
        
    }

    async getShippingItemsByInitial(){
        await this.$apiClient.doRequest('get',`/shipping_items/tenantId?with_hidden=true&tenant_id=${this.selectedShippingGroupId}`).then((res) => {
            this.shippingItemsInital = res.shippingItems.sort((a:any,b:any) => a.name.localeCompare(b.name));
        })

    }


    csvDownload(){
        if(this.selectedCultivationName == 0){
            this.cvMethodName = "慣行"
        }
        if(this.selectedCultivationName == 1){
            this.cvMethodName = "特栽"
        }
        if(this.selectedCultivationName == 2){
            this.cvMethodName = "化学農薬・化学肥料不使用"
        }

        this.$apiClient.getRequest( `${this.baseUrl}/csv_export?&com_name=${this.searchQueryCommittee}&producer_name=${this.searchQueryProducers}&sitem_name=${this.searchQueryShippingItems}&crop_name=${this.searchQuerySeedlings}&planting=${this.searchQueryPlanting}&agri_field_name=${this.selectedAgriFieldName}&agri_field_num=${this.selectedAgriFieldNum}&cv_method=${this.cvMethodName ? this.cvMethodName : ""}&chemical_hidden_flag=${this.chemicalHiddenFlag}&cultivation_with_producer=${this.cultivationWithProducer}&cultivation_with_out_producer=${this.cultivationWithOutProducer}`).then((res: CsvDownload) => {
            this.$apiClient.csvDownload(res)
        }).catch(error=>{
            this.$toasted.error('データの取得に失敗しました。')
        })
    }

    getCvMethod(value: number): string {
      const mapping: Record<number, string> = {
        0: '慣行',
        1: '特栽',
        2: '化学農薬・化学肥料不使用'
      };
      return mapping[value];
    }

    //部会
    clearSearchQueryCommittee(){
        this.searchQueryCommittee= '';
        this.selectedCommitteeId = '';
        this.searchQueryPlanting = '';
        this.searchQuerySeedlings = '';
        this.producers = [];
        this.shippingItems = [];
        this.plantings = [];
        this.seedlings = [];
        this.handleSearch();
    }

    selectCommittee(committee: any) {
        this.searchQueryCommittee = committee.name;
        this.isCommitteesDropdownVisible = false;
        this.handleSearch();
    }

    hideCommitteesDropdown() {
        if(this.searchQueryCommittee!=""){
            const query = this.searchQueryCommittee || '';
            const filtered = this.committees.filter(c => c.name === query);
            if (filtered.length > 0) {
               this.selectedCommitteeId = filtered[0].id;
            }
        }
        this.isCommitteesDropdownVisible = false;
        this.filterCommitteeName();
        this.filterProducerNames();
        this.getPlantings();
        this.getSeedlings();
    }

    filterCommitteesDropdown() {
    this.isCommitteesDropdownVisible = true;
    }
   
    get filteredCommittees() {
        const committees = this.includeHiddenFlag
        ? this.committees
        : this.committees.filter(c =>!c.is_hidden);
        if (!this.searchQueryCommittee) {
            return committees;
        }
        const filtered = committees.filter(committee =>
            committee.name.includes(this.searchQueryCommittee)
        );
        return filtered;
    }

   async filterShippingItems() {
        const query = this.searchQueryCommittee || '';
        const filtered = this.committees.filter(c => c.name === query);
        if (filtered.length > 0) {
            this.selectedCommitteeId = filtered[0].id;
           await this.getShippingItems();
            this.shippingItems= this.shippingItems.filter(item => item.comId === this.selectedCommitteeId);
        }else{
            this.shippingItems = [];
        }
    }

    async filterProducerNames(){
        const query = this.searchQueryCommittee || '';
        const filtered = this.committees.filter(c => c.name === query);  
            if (filtered.length > 0 &&(
            (!this.pesticidePlanProducer) ||
            (this.pesticidePlanProducer && this.isPesticidePlan))) {
           await this.getProducers();  
            this.selectedCommitteeId = filtered[0].id;
            await this.$apiClient.doRequest("get", `/committees/${this.selectedCommitteeId}`).then((res) => {
            const validPdIds = (res.committeeWorkers as any[]).map((worker: any) => worker.pd_id);
            this.producers = this.producers.filter(producer => validPdIds.includes(producer.pdId));
            })
        }else{
            this.producers = [];
        }
    }

    //作付
    clearSearchQueryPlanting(){
        this.searchQueryPlanting= '';
        this.handleSearch();
    }

    selectPlanting(planting: any) {
        this.searchQueryPlanting = planting.name;
        this.isPlantingDropdownVisible = false;
        this.handleSearch();
      }

    hidePlantingDropdown() {
        this.isPlantingDropdownVisible = false;
    }

    filterPlantingDropdown() {
    this.isPlantingDropdownVisible = true;
    }

    get filteredPlanting() {
        const plantings = this.includeHiddenFlag
        ? this.plantings
        : this.plantings.filter(p =>!p.is_hidden);
        if (!this.searchQueryPlanting) {
            return plantings;
        }
        return plantings.filter(planting =>
            planting.name.includes(this.searchQueryPlanting)
        );
        
    }
    
    //氏名
    clearSearchQueryProducers(){
        this.searchQueryProducers= '';
        this.selectedPdId = '';
        this.getCommittees();
        this.filterShippingItems();
        this.plantings = [];
        this.seedlings = [];
        this.handleSearch();
    }

    selectProducers(producers: any) {
        this.searchQueryProducers = producers.pdName;
        this.isProducerDropdownVisible = false;
        this.handleSearch();
      }

    hideProducersDropdown() {
        this.isProducerDropdownVisible = false;
        this.filterCommitteeName();
        this.filterShippingItems();
        this.filterProducerByShippingItems();
        this.getPlantings();
        this.getSeedlings();
    }

    @Watch('searchQueryCommittee')
    private getProducerAndShippingDetails(){
        if (!this.searchQueryCommittee) {
            this.selectedCommitteeId = '';
        }
        this.filterProducerNames();
        this.filterShippingItems();
    }


    @Watch('searchQueryProducers')
    async getProducerId() {
        if (!this.searchQueryProducers) {
            this.selectedPdId = '';
            return;
        }
        try {
            const res = await this.$apiClient.doRequest(
            'get',
            `/producers/tenantId?with_hidden=true&tenant_id=${this.selectedShippingGroupId}`
            );
            this.producerPdId = res.producers;
            this.filterCommitteeName();
            const query = this.searchQueryProducers || '';
            this.filteredProducer = this.producerPdId.filter(c => c.pdName === query);

            if (this.filteredProducer.length > 0) {
                this.selectedPdId = this.filteredProducer[0].pdId;
            }

        } catch (error) {
            console.error('Error fetching producers:', error);
        }
    }

    filterCommitteeName() {
        if (this.searchQueryProducers !== '') {
            const query = this.searchQueryProducers || '';
            this.filteredProducer = this.producerPdId.filter(c => c.pdName === query);
            if (this.filteredProducer.length > 0) {
                this.selectedPdId = this.filteredProducer[0].pdId;
            } 
            try {
                const filteredWorkers = this.committeeWorkers.filter((worker: any) =>
                    worker.workerId === this.selectedPdId
                );

                const workerCommitteeIds = filteredWorkers.map((worker: any) => worker.id);

                this.committees = this.committees.filter((committee: any) =>
                    workerCommitteeIds.includes(committee.id)
                );
            } catch (error) {
                console.error('Failed to fetch workers:', error);
            }
        }
    }

    async getCommitteWorkers(){
        const res = await this.$apiClient.doRequest("get", `${this.comBaseUrlCommit}/workers`);
        this.committeeWorkers = res.committeeWorkers || [];

    }

    filterProducersDropdown() {
    this.isProducerDropdownVisible = true;
    }
   
    get filteredProducers() {
        const producers = this.includeHiddenFlag
        ? this.producers
        : this.producers.filter(p =>!p.is_hidden);
        if (!this.searchQueryProducers) {
            return producers;
        }
        const filtered = producers.filter(producer =>
            producer.pdName.includes(this.searchQueryProducers)
        );
        return filtered;
    }

    //品種
    clearSearchQuerySeedlings(){
        this.searchQuerySeedlings = '';
        this.handleSearch();
    }

    selectSeedlings(seedlings: any) {
        this.searchQuerySeedlings = seedlings.name;
        this.isSeedlingsDropdownVisible = false;
        this.handleSearch();
      }

    hideSeedlingsDropdown() {
        this.isSeedlingsDropdownVisible = false;
    }

    filterSeedlingsDropdown() {
    this.isSeedlingsDropdownVisible = true;
    }
   
    get filteredSeedlings() {
        const seedlings = this.includeHiddenFlag
        ? this.seedlings
        : this.seedlings.filter(s =>!s.is_hidden);
        if (!this.searchQuerySeedlings) {
            return seedlings;
        }
        const filtered = seedlings.filter(seedlings =>
            seedlings.name.includes(this.searchQuerySeedlings)
        );
        return filtered;
    }


    //出荷品目
    clearSearchQueryShippingItem(){
        this.searchQueryShippingItems= '';
        this.selectedShippingItemId = '';
        this.filterProducerByShippingItems();
        this.handleSearch();
    }

    selectShippingItem(shippingItems: any) {
        this.searchQueryShippingItems = shippingItems.name;
        this.isShippingItemDropdownVisible = false;
        this.handleSearch();
      }

    hideShippingItemDropdown() {
        this.isShippingItemDropdownVisible = false;
        this.filterProducerByShippingItems();
    }
    // @Watch("searchQueryShippingItems")
    async filterProducerByShippingItems(){
        if(this.searchQueryShippingItems != ''){
                const query = this.searchQueryShippingItems || '';
                this.filteredShippingItems = this.shippingItemsInital.filter(s => s.name === query);
                this.selectedShippingItemId = this.filteredShippingItems[0].id
                const res = await this.$apiClient.doRequest('get', `/shipping_items/${this.selectedShippingItemId}`);
                const producerIdsFromResponse = res.producers.map((p: { id: string }) => p.id);
                const filteredProducers = this.producers.filter(p => producerIdsFromResponse.includes(p.pdId));
                this.producers = filteredProducers;
        }else{
            this.selectedShippingItemId = '';
            this.filterProducerNames()

        }
    }

    filterShippingItemDropdown() {
    this.isShippingItemDropdownVisible = true;
    }
   
    get filteredShippingItem() {
        const shippingItem = this.includeHiddenFlag
        ? this.shippingItems
        : this.shippingItems.filter(s =>!s.is_hidden);
        if (!this.searchQueryShippingItems) {
            return shippingItem;
        }
        const filtered = shippingItem.filter(shippingItem =>
            shippingItem.name.includes(this.searchQueryShippingItems)
        );
        return filtered;
    }



  private sort(fieldName: string): void {
    this.sortOrder = !this.sortOrder;
    this.cultivationHistoryList.sort((a, b) => {
        const aValue = a[fieldName];
        const bValue = b[fieldName];
        if (aValue === null && bValue === null) return 0;
        if (aValue === null) return 1;
        if (bValue === null) return -1;
        if (typeof aValue === 'string' && typeof bValue === 'string') 
            return this.sortOrder ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
        if (typeof aValue === 'number' && typeof bValue === 'number') 
            return this.sortOrder ? aValue - bValue : bValue - aValue;
        return this.sortOrder ? String(aValue).localeCompare(String(bValue)) : String(bValue).localeCompare(String(aValue));
    });
 }

    formatDate(dateStr: string | null): string {
    return dateStr ? dateStr.replace(/-/g, '/') : '-';
    }

  formatRangeDate(dateStr: string | null):string {
    if (!dateStr) return '-';
    const [start, end] = dateStr.split('～').map(s => s.trim());
    
    const format = (d:any) => {
      const date = new Date(d);
      return date.getFullYear() + '/' + String(date.getMonth() + 1).padStart(2, '0') + '/' + String(date.getDate()).padStart(2, '0');
    };

    return `${format(start)}<br>～<br>${format(end)}`;
  }

 formatSowingAndPlantingDate(dateStr:any) {
    if (!dateStr) return '-';
    if (dateStr.includes('～')) {
      return dateStr.replace(/-/g, '/').replace(' ～ ', ' ～ ');
    } else {
      return dateStr.replace(/-/g, '/');
    }
  }


  dateNavigation(action: string) {
          this.validateDates()
          if(this.isButtonDisabled==false){
              const updateDate = (date: moment.MomentInput, offset: moment.DurationInputArg1, unit: moment.unitOfTime.Base) => moment(date).add(offset, unit).format('YYYY-MM-DD');
              const daysDifference = moment(this.selectedEndDate).diff(this.selectedStartDate, 'days')+1;
              const offset = (action === 'previous') ? -daysDifference : daysDifference;
              this.selectedStartDate = updateDate(this.selectedStartDate, offset, 'days');
              this.selectedEndDate = updateDate(this.selectedEndDate, offset, 'days');
              this.startDate = this.selectedStartDate;
              this.endDate = this.selectedEndDate;
              this.handleSearch();
          } else {
              this.isButtonDisabled = false
          }
      }

     validateDates() {
        if (this.selectedStartDate > this.selectedEndDate) {
          this.selectedStartDate = this.startDate;
          this.selectedEndDate = this.endDate;
          this.isButtonDisabled = true
        } else {
          this.isButtonDisabled = false
          this.startDate = this.selectedStartDate;
          this.endDate = this.selectedEndDate;
        }
    }

    validateDateCheck(){
        if ((this.selectedStartDate > this.selectedEndDate) || (this.selectedStartDate === '' && this.selectedEndDate === '') || (this.selectedStartDate === '' && this.selectedEndDate !== '') 
            || (this.selectedStartDate !== '' && this.selectedEndDate === '')||(this.selectedStartDate == null && this.selectedEndDate == null)||(this.selectedStartDate != null && this.selectedEndDate == null)||(this.selectedStartDate == null && this.selectedEndDate != null)) {
            this.isButtonDisabled = true;
          }else{
            this.isButtonDisabled = false;
          }
    }

    public validateInputInteger(event: InputEvent) {
        const input = event.target as HTMLInputElement;
        const currentValue = input.value;
        const data = event.data;

        if (data === null) return;

        if (/^\d$/.test(data)) return;

        if (data === '-' && !currentValue.includes('-')) return;

        event.preventDefault();
    }


    get selectedShippingGroupName() {
        const selected = this.shippingGroupList.find(
        item => item.tenantId === this.selectedShippingGroupId
        );
        return selected ? (selected.companyName || selected.name) : '';
  }

    toggleSidebar = () => {
    document.body.classList.toggle('sideopen')
    }

    mounted() {
        this.adjustSticky()
        window.addEventListener('resize', this.adjustSticky)
        this.$nextTick(() => {
            const lists = document.querySelectorAll<HTMLDivElement>(".chemical-list");
            lists.forEach((list) => {
            const items = list.querySelectorAll("div");
            if (items.length > 3) {
                list.classList.add("collapsed", "has-more");
            }
            });
        });
    }

  beforeDestroy() {
    window.removeEventListener('resize', this.adjustSticky)
  }

  adjustSticky() {
    const matchMedia = window.matchMedia('(max-width:1000px)')
    if (matchMedia.matches) {
      document.querySelectorAll<HTMLElement>('.stky-tr').forEach(box => {
        const row1 = box.querySelector<HTMLElement>('.d-stky-col-sp2')
        const row2 = box.querySelector<HTMLElement>('.d-stky-col-sp3')
        const row3 = box.querySelector<HTMLElement>('.d-stky-col-sp4')

        if (row1 && row2 && row3) {
          const row1Height = row1.offsetHeight
          row2.style.top = `${row1Height}px`
          row3.style.top = `${row1Height}px`
        }
      })
    }
  }

toggleExpand(rowIndex: number) {
    if (this.expandedRows.includes(rowIndex)) {
        this.expandedRows = this.expandedRows.filter(i => i !== rowIndex);
    } else {
        this.expandedRows.push(rowIndex);
    }
}

toggleExpandAlert(rowIndex: number) {
    if (this.expandedAlertRows.includes(rowIndex)) {
        this.expandedAlertRows = this.expandedAlertRows.filter(i => i !== rowIndex);
    } else {
        this.expandedAlertRows.push(rowIndex);
    }
}

handleExpand() {
      const lists = document.querySelectorAll(".chemical-list");
      this.expandedRows = []; 
      const listAlert = document.querySelectorAll(".cv-alert-list");
      this.expandedAlertRows = [];
      //chemical
      lists.forEach((list, index) => {
        if (this.expandAll) {
        list.classList.remove("hidden");
        this.expandedRows.push(index); 
        } else {
        const items = list.querySelectorAll("div");
        if (items.length > 3) {
            list.classList.add("hidden");
        }
        }
      });
      //Alert
      listAlert.forEach((list, index) => {
        if (this.expandAll) {
        list.classList.remove("hidden");
        this.expandedAlertRows.push(index); 
        } else {
        const items = list.querySelectorAll("div");
        if (items.length > 3) {
            list.classList.add("hidden");
        }
        }
      });
   }

    getAlignedUpperLimitList(cultivationList: any): string[] {
        const nameList: string[] = cultivationList.pesticideIngredientName
        ? cultivationList.pesticideIngredientName.split("::")
        : [];

        const upperLimitRaw: string[] = cultivationList.pesticidesIngredientsUpperLimit
        ? cultivationList.pesticidesIngredientsUpperLimit.split("::")
        : [];

        const map: Record<string, string> = {};

        upperLimitRaw.forEach((item: string) => {
        const [name, count] = item.split(":");
        if (name && count) {
            map[name.trim()] = count.trim();
        }
        });

        return nameList.map((name: string) => {
        return map[name] ? `${name}:${map[name]}` : `${name}:-`;
        });
  }
  private toggleLegend = () => {
    const box = document.getElementById("boxlegend");
    if (box) {
      box.classList.toggle("openlg");
    }
  };
}

